import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../../api/axios';

const PRIMARY = '#1558E0';

function PaymentSuccess() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const appointmentIdParam = searchParams.get('appointment_id');
    if (!appointmentIdParam) {
      setLoading(false);
      return;
    }
    api.get('appointments/user/my-bookings/')
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [searchParams]);

  if (loading) {
    return (
      <div
        className="min-vh-100 d-flex align-items-center justify-content-center"
        style={{ background: '#F5F7FB' }}
      >
        <div className="spinner-border" style={{ color: PRIMARY }} role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div
      className="min-vh-100 d-flex align-items-center justify-content-center p-3"
      style={{ background: '#F5F7FB' }}
    >
      <div
        className="bg-white w-100 text-center"
        style={{
          maxWidth: 400,
          borderRadius: 24,
          boxShadow: '0 16px 40px rgba(15, 23, 42, 0.08)',
          padding: '40px 32px 32px',
        }}
      >
        {/* Success icon + decorative sparkles */}
        <div className="position-relative d-inline-block mb-4" style={{ width: 140, height: 140 }}>
          {/* Decorations */}
          <span
            style={{
              position: 'absolute',
              top: 18,
              left: 8,
              width: 8,
              height: 8,
              borderRadius: '50%',
              background: PRIMARY,
              opacity: 0.85,
            }}
          />
          <span
            style={{
              position: 'absolute',
              top: 48,
              left: 0,
              width: 5,
              height: 5,
              borderRadius: '50%',
              background: PRIMARY,
              opacity: 0.55,
            }}
          />
          <span
            style={{
              position: 'absolute',
              bottom: 28,
              left: 14,
              width: 8,
              height: 8,
              background: PRIMARY,
              opacity: 0.7,
              transform: 'rotate(45deg)',
            }}
          />
          <span
            style={{
              position: 'absolute',
              top: 12,
              right: 10,
              width: 9,
              height: 9,
              background: PRIMARY,
              opacity: 0.75,
              transform: 'rotate(45deg)',
            }}
          />
          <span
            style={{
              position: 'absolute',
              top: 52,
              right: 2,
              width: 6,
              height: 6,
              borderRadius: '50%',
              background: PRIMARY,
              opacity: 0.5,
            }}
          />
          <span
            style={{
              position: 'absolute',
              bottom: 36,
              right: 12,
              width: 5,
              height: 5,
              borderRadius: '50%',
              background: PRIMARY,
              opacity: 0.65,
            }}
          />

          <div
            className="d-flex align-items-center justify-content-center rounded-circle position-absolute top-50 start-50 translate-middle"
            style={{
              width: 96,
              height: 96,
              background: PRIMARY,
              boxShadow: '0 14px 32px rgba(21, 88, 224, 0.4)',
            }}
          >
            <i className="bi bi-check-lg text-white" style={{ fontSize: 52, lineHeight: 1, fontWeight: 700 }} />
          </div>
        </div>

        <h3
          className="fw-bold mb-3"
          style={{ color: PRIMARY, fontSize: 26, letterSpacing: '-0.02em' }}
        >
          Payment Successful!
        </h3>

        <p
          className="mb-4 mx-auto"
          style={{ color: '#6B7280', fontSize: 14, lineHeight: 1.6, maxWidth: 280 }}
        >
          Your payment has been received successfully.
          <br />
          Thank you for choosing us.
        </p>

        <button
          type="button"
          className="btn w-100 fw-bold text-white border-0"
          style={{
            background: PRIMARY,
            borderRadius: 10,
            padding: '13px 16px',
            fontSize: 16,
          }}
          onClick={() => navigate('/user/bookings')}
        >
          Done
        </button>
      </div>
    </div>
  );
}

export default PaymentSuccess;
